// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep .el-cascader-menu {\n  height: 100% !important;\n}\n::v-deep .el-cascader-menu__wrap {\n  height: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
